export { PxtraApiClientLegacy } from "./client";
export * from "./structs";
export { blobToBase64 } from "../core/helper";

export const receiptBenefits = [
  "essenszuschuss",
  "öpnv_tickets",
  "telefonkosten",
  "internetpauschale",
  "betreuungskosten",
] as const;
